/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorHospitalAssociation from './doctor-hospital-association';
import DoctorHospitalAssociationDetail from './doctor-hospital-association-detail';
import DoctorHospitalAssociationUpdate from './doctor-hospital-association-update';
import DoctorHospitalAssociationDeleteDialog from './doctor-hospital-association-delete-dialog';

const DoctorHospitalAssociationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorHospitalAssociation />} />
    <Route path="new" element={<DoctorHospitalAssociationUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorHospitalAssociationDetail />} />
      <Route path="edit" element={<DoctorHospitalAssociationUpdate />} />
      <Route path="delete" element={<DoctorHospitalAssociationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorHospitalAssociationRoutes;
